export default __webpack_public_path__ + "static/media/about_pic.858f2126.jpg";